import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../connection/api';
import alert_box from '../../../alert/alert_box';
import alert_msg from '../../../alert/alert_msg';

export default function EditBase({ basesData, onUpdateBase }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    base_name: '',
    circle_id: '',
   });
const findData=async()=>{

  try {
    const token = localStorage.getItem("token");
    const response = await api.get(`base/find/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log(response.data.data[0].base_name);
    if (response.data.success === true) {
      // const { base_name, circle_id } = response.data.data;
      setFormData({ base_name: response.data.data[0].base_name,
                    circle_id: response.data.data[0].circle_id 
      });
    } else {
      alert_box('هەڵە ڕویدا',response.data.message,'error','ok');
    }
  } catch (error) {
    
  }
}

const [bazna, setBazna] = useState([]);
const [errors, setErrors] = useState({});

const getCircle = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await api.get("/circle/index", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });
    setBazna(response.data.AllData);
    // console.log(localStorage.getItem('role'));
    // console.log(bazna.circle_name);
  } catch (error) {
    console.error("Error fetching circles:", error);
  }
};

  useEffect(() => {
    getCircle(); 
    findData();
    // console.log(formData);

    // const base = basesData.find(item => item.id === parseInt(id));
    // if (base) {
    //   const { established, ...baseData } = base; // Remove established from base data
    //   setFormData({
    //     name: base.name,
    //     region: base.region,
    //     address: base.address
    //   });
    // }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit =async (e) => {
    e.preventDefault();
    
    try {
      const token = localStorage.getItem("token");
    const response=await api.post(`base/update/${id}`, formData,{
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });
// return console.log(response);
    if (response.data.success === true) {
      navigate('/base');
      alert_msg('زانیاری بنکە بە سەرکەوتوویی نوێکرایەوە','success');
    }
    else{
      alert_box('هەڵە ڕویدا',response.data.message,'error','ok');
    }
    } catch (error) {
      console.log(error);
    }
     
   
  };

  const handleCancel = () => {
    navigate('/bases');
  };

 
  return (
    <div className="page active">
      <div className="page-header">
        <h1>دەستکاریکردنی زانیاری بنکە</h1>
        <p>زانیاری بنکە نوێ بکەرەوە</p>
      </div>

      <div className="form-page">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">ناوی بنکە *</label>
            <input 
              type="text" 
              id="base_name" 
              name="base_name" 
              required
              value={formData.base_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="circle_id">بازنە *</label>
            <select 
              id="circle_id" 
              name="circle_id" 
              required
              value={formData.circle_id}
              onChange={handleChange}
              className={errors.circle_id ? 'has-error' : ''}
            >
              <option value="">بازنە هەڵبژێرە</option>
              {/* {renderOptions(bazna)} */}
               {localStorage.getItem('role')==='admin' && bazna  && ( 
           <option key={bazna.id} value={bazna.id}>
           {bazna.circle_name}
         </option>
      
               )} 

               {localStorage.getItem('role')==='superadmin' && bazna  && Array.isArray(bazna) && bazna.length > 1 && bazna.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.circle_name}
                </option>
              )) 
           }
              
              
            </select>
            {/* {renderFieldErrors('circle_id')} */}
          </div>

          {/* <div className="form-group">
            <label htmlFor="address">ناونیشان *</label>
            <input 
              type="text" 
              id="address" 
              name="address" 
              required
              value={formData.address}
              onChange={handleChange}
            />
          </div> */}

<div className="form-actions">
            <button type="submit" className="btn-primary">
              <i className="fas fa-save"></i>
              نوێکردنەوە
            </button>
            <button type="button" className="btn-secondary" onClick={handleCancel}>
              <i className="fas fa-arrow-right"></i>
              گەڕانەوە
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
